// Every legal page, linked from the footer for every visitor. These pages are where the
// operating company's name, number and registered office are disclosed.
export const LEGAL_LINKS = [
  { text: 'Terms of Use', href: '/terms-of-use' },
  { text: 'Privacy Policy', href: '/privacy-policy' },
  { text: 'Cookie Policy', href: '/cookie-policy' },
  { text: 'Disclaimer', href: '/disclaimer' },
  { text: 'Subscription Terms', href: '/subscription-terms' },
] as const;
